export const COLOUR_FACET_ID = "base_colour";
export const RECEIVE_COLOUR_ENRICHMENT = "RECEIVE_COLOUR_ENRICHMENT";
export const COLOUR_ENRICHMENT_LANG = "en-GB";
export const COLOUR_ENRICHMENT_CHANNEL = "desktop-web";
